// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Route } from 'react-router';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import { history } from '../store';

import AppContainer from './AppContainer';

export default ({ store }) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider>
        <Route path="/" component={AppContainer} />
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>
);



// WEBPACK FOOTER //
// ./components/Root.js